var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.5L12.5 5C12.5 3.89543 11.6046 3 10.5 3L5.5 3C4.39543 3 3.5 3.89543 3.5 5L3.5 15C3.5 16.1046 4.39543 17 5.5 17L10.5 17C11.6046 17 12.5 16.1046 12.5 15L12.5 14.5",
    stroke: "#E74343",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10L13 9.25L13 10ZM8.5 9.25C8.08579 9.25 7.75 9.58578 7.75 10C7.75 10.4142 8.08579 10.75 8.5 10.75L8.5 9.25ZM13 10.75L18 10.75L18 9.25L13 9.25L13 10.75ZM8.5 10.75L13 10.75L13 9.25L8.5 9.25L8.5 10.75Z",
    fill: "#E74343"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10L16.5 8.5L15.75 7.75",
    stroke: "#E74343",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10L16.5 11.5L15.75 12.25",
    stroke: "#E74343",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logoutIcon.846523abe7af23c7cf379ad697c7db1c.svg";
export { ForwardRef as ReactComponent };